import { Deserializable } from './deserializable';
import { BaseModel } from './base.model';

export class ZoneModel extends BaseModel implements Deserializable {

  // columns
  zone_id: number; // tslint:disable-line: variable-name
  zone_name: string; // tslint:disable-line: variable-name
  country_code: string; // tslint:disable-line: variable-name

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
